import React from 'react';
import SinglePolygon from '../SinglePolygon/SinglePolygon';
import MultiPolygonsUnEditable from '../MultiPolygons/MultiPolygonsUnEditable/MultiPolygonsUnEditable';
import { useSelector } from 'react-redux';
import {
    isMapZoomingState,
    isUsePolygonClusterState,
    multiPolygonsInfoState,
    singlePolygonCoordsState,
} from '../../../../../../app/redux/retrievers/retrievers';
import PolygonCluster from '../PolygonCluster/PolygonCluster';

interface PolygonLayerUneditableProps {
    isEditable: boolean;
}
const PolygonLayerUneditable: React.FC<PolygonLayerUneditableProps> = ({ isEditable }) => {
    const isMapZooming = useSelector(isMapZoomingState);
    // const singlePolygonCoords = useSelector(singlePolygonCoordsState);
    // const multiPolygonsInfo = useSelector(multiPolygonsInfoState);
    // const usePolygonClusterState = useSelector(isUsePolygonClusterState);

    // const isUsePolygonCluster = usePolygonClusterState || (multiPolygonsInfo.length > 20 && singlePolygonCoords.length < 3);

    return (
        <>
            {!isEditable && !isMapZooming && <SinglePolygon />}
            {/* {!isMapZooming && !isUsePolygonCluster ? <MultiPolygonsUnEditable /> : !isMapZooming && <PolygonCluster />} */}
            {!isMapZooming && <MultiPolygonsUnEditable />}
        </>
    );
};

export default PolygonLayerUneditable;
